<template>
  <section class="enrolment-congratulations">
    <header class="enrolment-congratulations__header">
      <span class="enrolment-congratulations__icon" aria-hidden="true">
        <img src="~/images/check-fill.svg" class="icon" v-svg-inline>
      </span>
      <div>
        <p class="enrolment-congratulations__caption">Поздравляем с зачислением</p>
        <h3>Уважаемый будущий кандидат наук!</h3>
      </div>
    </header>

    <div class="enrolment-congratulations__body">
      <p>
        Приветствуем вас в научном сообществе ТУСУРа! Поздравляем с новым важным этапом —
        вашим зачислением в аспирантуру Томского государственного университета систем
        управления и радиоэлектроники (ТУСУР).
      </p>
      <p>
        Поступление в аспирантуру — это выбор стать тем, кто создаёт будущее, а не просто
        следует ему. Вы уже доказали, что способны на большее. Теперь ваша задача —
        совершить прорыв.
      </p>
      <p>Мы готовы поддержать ваши самые смелые научные идеи.</p>
    </div>

    <footer class="enrolment-congratulations__footer">
      <p>
        С уважением,<br>
        <strong>Отдел аспирантуры и докторантуры!</strong>
      </p>
    </footer>
  </section>
</template>
